<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="6">
          <b-form-group label="From" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>

        </b-col>
        <b-col lg="6">
          <b-form-group label="To" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate >= toDate">
            Search
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

  <b-card v-if="buildings.length > 0" no-body>
    <building-revenue-report :buildings="buildings"></building-revenue-report>
  </b-card>

  <b-card v-if="buildings.length > 0" no-body>
    <building-revenue-bar-chart :buildings="buildings"></building-revenue-bar-chart>
  </b-card>

</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import BuildingRevenueBarChart from './BuildingRevenueBarChart'
import BuildingRevenueReport from './BuildingRevenueReport'

export default {
  name: 'OccupancyReport',
  components: {
    BuildingRevenueBarChart,
    BuildingRevenueReport
  },
  data: function() {
    return {
      fromDate: new Date(),
      toDate: this.$moment().add(7, 'days').toDate(),
      buildings: [],
    }
  },
  methods: {
    search() {
      this.buildings = []
      let params = {
        from: this.formatDate(this.fromDate),
        to: this.formatDate(this.toDate)
      }
      Vue.axios.get('admin/reports/revenue-by-range', {params: params})
      .then(response => {
        this.buildings = response.data.data
        this.showSuccessMsg()
      })
      .catch ( error => {
        this.showErrorMsg()
      });
    }
  },
  created () {
  }
}
</script>
